<template>
    <v-container>
        <v-flex class="ypo-region">
            <h4>{{SpeakerApplicants.REGION}}</h4>
            <v-flex pb-3>
                <v-flex class="form-control">
                    <v-chip
                        v-if="speakerRegionFilter.length > 0"
                        close
                        @input="removeRegion">
                        {{ speakerRegionFilter }}
                    </v-chip>
                    <v-select
                        class="mt-1"
                        data-qe-id="region-filter_drop_down"
                        :items="Object.values(regionList).sort()"
                        v-model="speakerRegionFilter"
                        @change="regionChange()"></v-select>
                </v-flex>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";

    export default {
        name: "SearchSpeakerRegion",
        data: () => ({
            SpeakerApplicants,
            speakerRegionFilter: '',
        }),
        props: {
            applySpeakerFilter: {
                type: Function,
                required: true,
            },
        },
        created() {
            this.getRegionListForCFF();
            this.checkSpeakersRegionFilter();
        },
        methods: {
            ...mapActions({
                getRegionListForCFF: `speaker/${storeAction.getRegionListForCFF}`,
            }),
            regionChange() {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        region: this.speakerRegionFilter,
                    },
                });
            },
            removeRegion() {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        region: '',
                    },
                });
            },
            checkSpeakersRegionFilter(value = this.$route.query.region) {
                if (value && value.length) {
                    this.speakerRegionFilter = value;
                    this.applySpeakerFilter([{
                        label: 'RegionName',
                        filterKey: 'RegionName',
                        filterValue: value,
                    }]);
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                regionList: `speaker/${storeGetters.regionListForCFFNames}`,
            }),
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .ypo-region {
        .v-input__control {
            min-height: 38px;

            .v-input__slot {
                border: 1px solid $ypo-tile-border;
                box-shadow: none;
                border-radius: 3px;
                font-size: 12px;
                padding-left: 10px;

                &::before {
                    border-color: inherit;
                }
            }

        }
    }
</style>
